// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Currency from "../../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Row$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as LabelUnit$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/label-unit/LabelUnit.bs.js";
import * as PricingDashboardAssetsManager from "../../../assets/PricingDashboardAssetsManager.bs.js";

var delta_positive = PricingDashboardAssetsManager.getImage("delta-plus.svg");

var delta_negative = PricingDashboardAssetsManager.getImage("delta-negative.svg");

function getFloatDelta(delta) {
  var delta_float = Currency.fromOptCurrency(delta);
  if (delta_float !== undefined && delta_float !== 0.0) {
    if (delta_float < 0.0) {
      return React.createElement("div", {
                  className: "delta-negative"
                }, "(", React.createElement("img", {
                      src: delta_negative
                    }), Math.abs(delta_float), ")");
    } else {
      return React.createElement("div", {
                  className: "delta-positive"
                }, "(", React.createElement("img", {
                      src: delta_positive
                    }), delta_float, ")");
    }
  } else {
    return null;
  }
}

function getIntDelta(delta) {
  if (delta !== undefined && delta !== 0) {
    if (delta < 0) {
      return React.createElement("div", {
                  className: "delta-negative"
                }, "(", React.createElement("img", {
                      src: delta_negative
                    }), Math.abs(delta), ")");
    } else {
      return React.createElement("div", {
                  className: "delta-positive"
                }, "(", React.createElement("img", {
                      src: delta_positive
                    }), delta, ")");
    }
  } else {
    return null;
  }
}

function CorePricingViewUtils$LineItem(Props) {
  var label = Props.label;
  var unit = Props.unit;
  var value = Props.value;
  return React.createElement(Row$Catalyst.make, {
              children: null,
              className: ""
            }, unit !== undefined ? React.createElement(LabelUnit$Catalyst.make, {
                    label: label,
                    unit: unit
                  }) : React.createElement("div", undefined, label), React.createElement("div", undefined, value));
}

var LineItem = {
  make: CorePricingViewUtils$LineItem
};

export {
  delta_positive ,
  delta_negative ,
  getFloatDelta ,
  getIntDelta ,
  LineItem ,
  
}
/* delta_positive Not a pure module */
